import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExecutionQueue {

  private queue = new Set<string>();
  private running = false;

  enqueue(field: string) {
    this.queue.add(field);
  }

  flush(run: (field: string) => void) {

    if (this.running) return;

    this.running = true;

    while (this.queue.size > 0) {

      const [field] = Array.from(this.queue);
      this.queue.delete(field);

      run(field);
    }

    this.running = false;
  }
}